import { createProfessionalExporter } from '../../../utils/professionalExport';
import { formatPrice } from './financialData';

const headers = ['Payment ID', 'Gym', 'Plan', 'Amount', 'Billing Cycle', 'Paid On', 'Method', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Subscription Payments',
  headers,
  slug: 'financial-payments',
  brand: 'owner',
  getRows: (list) =>
    list.map((payment) => [
      payment.id,
      payment.gym,
      payment.plan,
      formatPrice(payment.amount),
      payment.billingCycle,
      payment.paidOn,
      payment.method,
      formatStatus(payment.status),
    ]),
  getSummary: (list) => [
    `Total payments: ${list.length}`,
    `Paid: ${list.filter((p) => p.status === 'paid' || p.status === 'completed').length}`,
  ],
});

export const printFinanceList = (data) => exporter.print(data);
export const exportFinanceCsv = (data) => exporter.csv(data);
export const exportFinanceExcel = (data) => exporter.excel(data);
export const exportFinancePdf = (data) => exporter.pdf(data);
export const exportFinance = (data) => exporter.export(data);
